export const projects = [
  {
    title: "PhotoFolio - Image Gallery",
    subtitle: "React.js + Firebase",
    description:
      "A cloud-based image gallery application that allows users to securely upload, organize, and manage their photos using Firebase. Built with React.js and enhanced with toast notifications and loading indicators for a smooth user experience.",
    image: "/images/photofolio.jpg",
    link: "https://photofolio-database.vercel.app/",
  },
  {
    title: "Netflix Clone",
    subtitle: "React.js + TMDB API + Axios + Redux",
    description:
      "A responsive Netflix-inspired web application that fetches and displays the latest movies and TV shows from the TMDB API. Features dynamic content loading, category-based browsing, and state management using Redux.",
    image: "/images/netfix-ui-page.png",
    link: "https://netflix-clone-git-main-rishi-guptas-projects-ca5f8b45.vercel.app/",
  },
  {
    title: "Guess My Number Game",
    subtitle: "HTML + CSS + JavaScript",
    description:
      "An interactive number guessing game built with vanilla JavaScript. Players have 20 attempts to guess a randomly generated number between 1 and 20, showcasing DOM manipulation and game logic.",
    image: "/images/domgame.png",
    link: "https://javascript-project-game.vercel.app/",
  },
  {
    title: "Lock My Pass",
    subtitle: "React.js + Vite + Tailwind CSS",
    description:
      "A modern password generator that helps users create strong, secure, and customizable passwords. Includes options for password complexity and a clean, responsive interface for enhanced usability.",
    image: "/images/lockmypass.png",
    link: "https://lockmypass.vercel.app/",
  },
];

export const skills = [
  {
    skilly: "HTML & CSS",
  },
  {
    skilly: "SASS/ Tailwind/ MUI",
  },
  {
    skilly: "Javascript ES6, Velo by WiX",
  },
  {
    skilly: "DOM Manipulation",
  },
  {
    skilly: "Git (Github), Gitlab, Sandbox",
  },
  {
    skilly: "React JS (Routing, Context API, Hooks)",
  },
  {
    skilly: "Rest API, Axios",
  },
  {
    skilly: "UID (User Interface Design)",
  },
  {
    skilly: "Firebase CRUD , Authentication check",
  },
  {
    skilly: "UX/ UI & CMS Tools (WiX, Figma, Adobe XD)",
  },
];

export const certificate = [
  {
    title: "Advance Front-End Web Development with React",
    img: "/images/cn-front-end.png",
  },
  {
    title: "CSS By HackerRank",
    img: "/images/css-hackerrank.png",
  },
  {
    title: "TCS iON Soft Skills Certified",
    img: "/images/tcs-ion.png",
  },
  {
    title: "Visual Elements of UI Design by Coursera",
    img: "/images/ui-coursera.png",
  },
];
